"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    props: {
        title: { type: String, default: 'timer icon' },
        fill: { type: String, default: 'currentColor' },
        secondaryfill: { type: String, default: '' }
    }
};
